export default __webpack_public_path__ + "static/media/Malaki_Portfolio7.bae25f1e.webp";